import { render, staticRenderFns } from "./checkss.vue?vue&type=template&id=d50545c6&"
import script from "./checkss.vue?vue&type=script&lang=js&"
export * from "./checkss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports